

export default {
    methods: {
        handleFormSubmit (e) {
            e && e.preventDefault()
            this.form.validateFields((err, values) => {
                this.queryPolicyOrder(values)
            })
        },
        queryPolicyOrder (params) {
            this.$api.queryPolicyOrder({
                holderName: '',
                holderIdNumber: '',
                policyNo: '',
                ...params
            }).then(res => res.data).then(data => {
                this.info = data.content.length > 0 && data.content[0] || {}
            })
        }
    }
}